import "./style.css";
import { Routes, Route } from "react-router-dom";
import Home from "./componentes/Home";
import Login from "./componentes/Login";
import Cambios from "./componentes/Cambios";
import { AuthProvider } from "./context/authContext";
import { ProtectedRoute } from "./componentes/ProtectedRoute";


function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<Home data="entradas"/>} />
        <Route path="/login" element={<Login />} />
        <Route path="/cambios" element={<ProtectedRoute> <Cambios /> </ProtectedRoute>} />
      </Routes>
    </AuthProvider>

  );
}

export default App;
